export default __webpack_public_path__ + "static/media/seven11.ea749970.svg";